module.exports = __webpack_public_path__ + "assets/img/优鱼优选.32d925a2.png";